import { cva, VariantProps } from 'class-variance-authority'
import clsx from 'clsx'
import React, { InputHTMLAttributes } from 'react'

import { textVariants } from '@/components-latest/primitives/Text'

import Styles from './Input.module.scss'

const inputVariants = cva(
  clsx(Styles.inputBase, textVariants({ variant: 'nextBody' })),
  {
    variants: {
      intent: {
        positive: Styles.positive,
        negative: Styles.negative,
        default: Styles.filled
      }
    },
    defaultVariants: {
      intent: 'default'
    }
  }
)

export interface IInputProps
  extends InputHTMLAttributes<HTMLInputElement>,
    VariantProps<typeof inputVariants> {}

const Input = React.forwardRef<HTMLInputElement, IInputProps>(
  ({ className, children, intent, ...props }, ref) => {
    return (
      <input
        data-testid="input"
        className={clsx(Styles.input, className, inputVariants({ intent }))}
        ref={ref}
        {...props}>
        {children}
      </input>
    )
  }
)
Input.displayName = 'Input'

export { inputVariants }
export default Input
